module.exports = __webpack_public_path__ + "static/img/denglubeijing.2dd63e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/denglubeijing.jpg
// module id = g2ze
// module chunks = 25